import {  Observable, ObservedValueOf, OperatorFunction } from 'rxjs';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';



export abstract class IGraphQlService implements IGraphQlQueryExecutor {
  abstract getGraphQlResults(query: GraphQlQuery): Observable<any>
  abstract getGraphQlResultsSeries(query: GraphQlQuery, options: GraphQlResultsSeriesOptions): Observable<any>
  abstract executeGraphQl(graphQl: string): Observable<any>
  abstract getSchema(): Observable<any>
}

export interface GraphQlResultsSeriesOptions {
  nameTemplate?: string,
  valueConverter?: Function,
  operator?: OperatorFunction<any, ObservedValueOf<any>>
}




export interface GraphQlSelect {
  field: string,
  arguments?: object
}

export interface GraphQlQuery {
  /*width: number,
  height: number,
  chartHeader: string,
  xAxisLabel: string,
  yAxisLabel: string,*/
  dataset: string,
  selects: GraphQlSelect[],
  wheres?: GraphQLFilter[],
  groupBys?: GraphQLGroupBy[],
  page?: number,
  pageSize?: number,
  orderBy?: GraphQLOrderBy[],


}


export interface GraphQLFilter {
  path: string,
  comparison: GraphQLComparision,
  value: any,
  connector?: GraphQLConnector,
  groupedExpressions?: GraphQLFilter[]
}


export interface GraphQLOrderBy {
  path: string,
  descending?: boolean
}

export interface GraphQLGroupBy {
  path: string,
  timeUnit?:string
}




export enum GraphQLConnector {
  AND,
  OR
}



export interface IGraphQlQueryExecutor {
  getGraphQlResults(query: GraphQlQuery): Observable<any>;
}

